import { useState, useEffect } from 'react';
import RolesService from 'services/RolesService';

export default function useRoles() {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    async function fetchRoles() {
      try {
        const { data } = await RolesService.fetchAll();

        setRoles(data);
      } catch (error) {
        console.log(error.message);
      }
    }

    fetchRoles();
  }, []);

  return roles;
}
